<!-- 普通模式下的“日志导出” -->
<!-- 新需求需要在export-simple中适配极简模式下的“日志导出” -->
<n-slide-window [(visible)]="show"
    id="exportSlideWindow"
    width="800px"
    [loading]="loading"
    (onHide)="onHide()">
    <n-header class="flex-wrapper">
        <h1 [innerHTML]="i18n.title"></h1>
        <n-help-link key="storagesysExport"></n-help-link>
    </n-header>

    <p *ngIf="isChrome" class="mb30">
        <svg class="icon operation">
            <use xlink:href="#icon-status-info"></use>
        </svg>
        {{ i18n.chromeExplain }}
    </p>

    <form [formGroup]="formGroup"
        autocomplete="off"
        [errorMessage]="errorMessage"
        *ngIf="selectedType !== logType.performanceFile && selectedType !== logType.DISK_RUNING_STATUS_DATA"
        [simpleMode]="SWITCH.IS_SIMPLE_MODE"
        [class.form-width-simple]="SWITCH.IS_SIMPLE_MODE">
        <n-form-item [label]="i18n.encryptLab">
            <n-checkbox [label]="i18n.isEncryptLab"
                id="encrypt-checkbox"
                formControlName="encryption"
                (onChange)="restInput()">
            </n-checkbox>
            <n-tip *ngIf="formGroup.value.encryption"
                [type]="'info'"
                [content]="i18n.useEncryptTip">
            </n-tip>
        </n-form-item>
        <ng-container *ngIf="formGroup && formGroup.value.encryption">
            <n-form-item [label]="i18n.encryptPasswordLab"
                [required]="true">
                <!-- 添加一个隐藏的输入框来欺骗firefox等浏览器的自动填充 -->
                <input type="password" class="hidden">
                <input nInput
                    id="encrypt_password_input"
                    type="password"
                    autocomplete="off"
                    autofocus
                    formControlName="key"
                    [placeholder]="errorMessage.key.rangeByteLength"
                    [nTooltip]="keyTip"
                    nTooltipTrigger="focus"
                    [nTooltipPlacement]="'top'" />
                <ng-template #keyTip>
                    <ul class="input-tip">
                        <li *ngFor="let item of keyTips"
                            [innerHTML]="item">
                        </li>
                    </ul>
                </ng-template>
            </n-form-item>
            <n-form-item [label]="i18n.encryptConfirmPasswordLab"
                [required]="true">
                <input nInput
                    id="encrypt_confirmPassword_input"
                    type="password"
                    autocomplete="off"
                    [placeholder]="errorMessage.key.rangeByteLength"
                    formControlName="confirmKey"
                    onpaste="return false;" />
            </n-form-item>
        </ng-container>
    </form>

    <div class="log-type-box">
        <div *ngFor="let item of exportItems"
            class="box-item"
            [id]="'box-item-'+item.type"
            [nTooltip]="item.tips"
            [class.selected]="item.type === selectedType"
            (click)="onClickItem(item.type)">
            <div class="item-icon">
                <svg>
                    <use [attr.xlink:href]="item.icon"></use>
                </svg>
            </div>
            <div class="item-text">{{item.label}}</div>
            <div [class.loading]="item.isLoading"></div>
        </div>
    </div>

    <p class="description mt10">{{ i18n[selectedType] }}</p>

    <!-- 按节点导出 -->
    <div [class.hidden]="hideExportByNodeData" class="mt10">
        <div>
            <n-switch id="export-by-nodes"
                [(ngModel)]="isExportByNode"
                [disabled]="isExportingLog"
                (onChange)="exportByNodeChange($event)">
            </n-switch>
            <span class="ml10">{{ i18n.exportByNode }}</span>
        </div>
        <n-transfer-table
            *ngIf="isExportByNode"
            #transferTable
            id="node-table"
            class="mt10"
            style="height: 350px"
            [data]="nodeData"
            [config]="nodeTableConfig"
            [leftColumnDefs]="nodeColumnDefs"
            [(selection)]="nodeSelection"
            (selectionChange)="nodeSelectionChange()"
            [leftTitle]="i18n.availableNode"
            [rightTitle]="i18n.selectedNode">
        </n-transfer-table>
    </div>

    <div class="export-btn-area mt30">
        <!-- 系统日志 -->
        <ng-container *ngIf="selectedType === logType.system">
            <div class="flex-div">
                <div *ngIf="btnMap[logType.system].visible" class="mr30">
                    <button nButton type="text"
                        id="recent-btn"
                        [disabled]="recentBtnDisable"
                        [icon]="btnMap[logType.system].icon"
                        [label]="btnMap[logType.system].label"
                        [loading]="btnMap[logType.system].loading"
                        [disabledTips]="recentBtnDisableTip"
                        (click)="onDownload(logType.system)">
                    </button>
                    <n-help-icon
                        class="title-tip"
                        [class.hidden]="recentBtnDisable || FeatureConfig.IsHideCabinetAndExpansion"
                        [content]="i18n.exportRecentLogTip">
                    </n-help-icon>
                    <br>
                    <div
                        [class.hidden]="recentBtnDisable"
                        [innerHTML]="btnMap[logType.system].tip">
                    </div>
                </div>
                <div *ngIf="btnMap[logType.system+'all'].visible" class="mr30">
                    <button nButton type="text"
                        id="all-log-btn"
                        [disabled]="suportNodeExportBtnDisable"
                        [disabledTips]="numUpLimitTip"
                        [icon]="btnMap[logType.system+'all'].icon"
                        [label]="btnMap[logType.system+'all'].label"
                        [loading]="btnMap[logType.system+'all'].loading"
                        (click)="onDownload(logType.system, true)">
                    </button>
                    <br>
                    <div
                        id="all-log-tip"
                        [class.hidden]="suportNodeExportBtnDisable"
                        [innerHTML]="btnMap[logType.system+'all'].tip">
                    </div>
                </div>
                <div *ngIf="btnMap[logType.system+'private'].visible">
                    <button nButton type="text"
                        id="private-btn"
                        [disabled]="suportNodeExportBtnDisable"
                        [disabledTips]="numUpLimitTip"
                        [icon]="btnMap[logType.system+'private'].icon"
                        [label]="btnMap[logType.system+'private'].label"
                        [loading]="btnMap[logType.system+'private'].loading"
                        (click)="onDownload(logType.system, null, true)">
                    </button>
                    <br>
                    <div
                        [class.hidden]="suportNodeExportBtnDisable"
                        [innerHTML]="btnMap[logType.system+'private'].tip">
                    </div>
                </div>
            </div>
        </ng-container>
        <!-- 硬盘日志 -->
        <ng-container *ngIf="selectedType === logType.disk">
            <div class="flex-div">
                <div *ngIf="btnMap[logType.dha].visible" class="mr30">
                    <button nButton type="text"
                        id="dha-log-btn"
                        [disabled]="suportNodeExportBtnDisable"
                        [disabledTips]="numUpLimitTip"
                        [icon]="btnMap[logType.dha].icon"
                        [label]="btnMap[logType.dha].label"
                        [loading]="btnMap[logType.dha].loading"
                        (click)="onDownload(logType.dha)">
                    </button>
                    <br>
                    <div
                        [class.hidden]="suportNodeExportBtnDisable"
                        [innerHTML]="btnMap[logType.dha].tip">
                    </div>
                </div>
                <div *ngIf="btnMap[logType.hssd].visible" class="mr30">
                    <button nButton type="text"
                        id="hssd-log-btn"
                        [disabled]="suportNodeExportBtnDisable"
                        [disabledTips]="numUpLimitTip"
                        [icon]="btnMap[logType.hssd].icon"
                        [label]="btnMap[logType.hssd].label"
                        [loading]="btnMap[logType.hssd].loading"
                        (click)="onDownload(logType.hssd)">
                    </button>
                    <br>
                    <div
                        [class.hidden]="suportNodeExportBtnDisable"
                        [innerHTML]="btnMap[logType.hssd].tip">
                    </div>
                </div>
                <div *ngIf="btnMap[logType.erase].visible">
                    <button nButton type="text"
                        id="erase-log-btn"
                        [disabled]="isExportByNode"
                        [icon]="btnMap[logType.erase].icon"
                        [label]="btnMap[logType.erase].label"
                        [loading]="btnMap[logType.erase].loading"
                        [disabledTips]="eraseBtnDisableTip"
                        (click)="onDownload(logType.erase)">
                    </button>
                    <br>
                    <div
                        [class.hidden]="isExportByNode"
                        [innerHTML]="btnMap[logType.erase].tip">
                    </div>
                </div>
            </div>
        </ng-container>
        <!-- 导出硬盘数据 -->
        <ng-container *ngIf="selectedType === logType.DISK_RUNING_STATUS_DATA">
            <button nButton type="text"
                [icon]="btnMap[logType.DISK_RUNING_STATUS_DATA].icon"
                [label]="btnMap[logType.DISK_RUNING_STATUS_DATA].label"
                [loading]="btnMap[logType.DISK_RUNING_STATUS_DATA].loading"
                (click)="onDownload(logType.DISK_RUNING_STATUS_DATA)">
            </button>
            <br>
            <div id="disk-data-tip"
                [innerHTML]="btnMap[logType.DISK_RUNING_STATUS_DATA].tip">
            </div>
        </ng-container>
        <!-- cloudBackup -->
        <ng-container *ngIf="selectedType === logType.cloudBackup">
            <button nButton type="text" *ngIf="btnMap[logType.cloudBackup].visible"
                [icon]="btnMap[logType.cloudBackup].icon"
                [label]="btnMap[logType.cloudBackup].label"
                [loading]="btnMap[logType.cloudBackup].loading"
                class="mr30"
                (click)="onDownload(logType.cloudBackup)">
            </button>
            <button nButton type="text" *ngIf="btnMap[logType.cloudBackup+'all'].visible"
                [icon]="btnMap[logType.cloudBackup+'all'].icon"
                [label]="btnMap[logType.cloudBackup+'all'].label"
                [loading]="btnMap[logType.cloudBackup+'all'].loading"
                (click)="onDownload(logType.cloudBackup, true)">
            </button>
        </ng-container>
        <!-- 配置信息 -->
        <ng-container *ngIf="selectedType === logType.runningData">
            <button nButton type="text"
                [icon]="btnMap[logType.runningData].icon"
                [label]="btnMap[logType.runningData].label"
                [loading]="btnMap[logType.runningData].loading"
                (click)="onDownload(logType.runningData)">
            </button>
            <br>
            <div id="runningData-tip"
                [innerHTML]="btnMap[logType.runningData].tip">
            </div>
        </ng-container>
        <!-- 全量故障诊断信息 -->
        <ng-container *ngIf="selectedType === logType.diagnostic">
            <button nButton type="text"
                [icon]="btnMap[logType.diagnostic].icon"
                [label]="btnMap[logType.diagnostic].label"
                [loading]="btnMap[logType.diagnostic].loading"
                (click)="onDownload(logType.diagnostic)">
            </button>
            <br>
            <div id="diagnostic-tip"
                [innerHTML]="btnMap[logType.diagnostic].tip">
            </div>
        </ng-container>
        <!-- 防病毒日志 -->
        <ng-container *ngIf="selectedType === logType.antivirus">
            <button nButton
                type="text"
                *ngIf="btnMap[logType.antivirus].visible"
                [icon]="btnMap[logType.antivirus].icon"
                [label]="btnMap[logType.antivirus].label"
                [loading]="btnMap[logType.antivirus].loading"
                (click)="onDownload(logType.antivirus)">
            </button>
        </ng-container>
        <!-- FTDS日志 -->
        <ng-container *ngIf="selectedType === logType.ftds">
            <button nButton
                type="text"
                *ngIf="btnMap[logType.ftds].visible"
                [icon]="btnMap[logType.ftds].icon"
                [label]="btnMap[logType.ftds].label"
                [loading]="btnMap[logType.ftds].loading"
                (click)="onDownload(logType.ftds)">
            </button>
            <br>
            <div id="ftds-tip"
                *ngIf="btnMap[logType.ftds].visible"
                [innerHTML]="btnMap[logType.ftds].tip">
            </div>
        </ng-container>

        <!-- 精简故障诊断信息 -->
        <ng-container *ngIf="selectedType === logType.streamlineDiagnostic">
            <app-streamline-dianostic [encryptionVm]="formGroup">
            </app-streamline-dianostic>
        </ng-container>

        <!-- 性能文件 -->
        <ng-container *ngIf="selectedType === logType.performanceFile">
            <ng-container *ngIf="hasConfigPMS; else PMSTip">
                <div>
                    <p>{{i18n.exportDataTimeLabel}}</p>
                    <n-calendar-section
                        [disabled]="btnMap[logType.performanceFile].loading"
                        class="mt10"
                        format="YYYY-MM-DD"
                        showDstWithoutTimePicker="true"
                        [(ngModel)]="dateRange"
                        (onFocus)="hideResult([logType.performanceFile])"
                        (onChange)="ondateRangeChange()">
                    </n-calendar-section>
                    <!-- 取消导出的tip -->
                    <n-help-icon class="title-tip" [content]="i18n.cancelExportPerfTip"></n-help-icon>
                    <!-- 超出可选日期的tip -->
                    <p class="mt10" *ngIf="!isTimeRangeValid">
                        <svg class="icon operation">
                            <use xlink:href="#app-icon-alarms-minor-new"></use>
                        </svg>
                        {{str.exportDataTimeLimitTip(30)}}
                    </p>
                </div>
                <div class="mt10">
                    <button nButton
                        [icon]="btnMap[logType.performanceFile].icon"
                        [label]="btnMap[logType.performanceFile].label"
                        [loading]="btnMap[logType.performanceFile].loading"
                        (click)="onDownload(logType.performanceFile)"
                        [disabled]="!isTimeRangeValid">
                    </button>
                    <!-- 取消导出 -->
                    <button nButton id="cancel-performanceFile-log-btn"
                        [label]="i18n.cancelBtn" [loading]="isCancelExportPerf"
                        (click)="cancelExportPerfLog()">
                    </button>
                </div>
                <br>
                <div id="performanceFile-tip"
                    [innerHTML]="btnMap[logType.performanceFile].tip">
                </div>
            </ng-container>
            <ng-template #PMSTip>
                <p>
                    {{i18n.noPmsLunNoDataTip}}
                    <a (click)="jumpToConfigPmsLun()">{{i18n.noPmsLunHistoricalDataTip}}</a>{{i18n.preiodLab}}
                </p>
            </ng-template>
        </ng-container>
        <n-tip *ngIf="resultMap[selectedType]?.show"
            [type]="resultMap[selectedType]?.isOk ? 'succeed' : 'error'">
            {{resultMap[selectedType].result}}
        </n-tip>
    </div>

    <div *ngIf="selectedType === logType.system" class="percent-bar-box">
        <n-percent-bar *ngIf="(btnMap[logType.system].loading) || (btnMap[logType.system+'all'].loading)"
            style="flex: 1;"
            [toFixed]="0"
            [value]="downloadProcess">
        </n-percent-bar>
    </div>

    <div *ngIf="selectedType === logType.antivirus " class="percent-bar-box">
        <n-percent-bar *ngIf="btnMap[logType.antivirus].loading"
            style="flex: 1;"
            [toFixed]="0"
            [value]="downloadProcess">
        </n-percent-bar>
    </div>

    <div *ngIf="selectedType === logType.ftds" class="percent-bar-box">
        <n-percent-bar *ngIf="btnMap[logType.ftds].loading"
            style="flex: 1;"
            [toFixed]="0"
            [value]="downloadProcess">
        </n-percent-bar>
    </div>

    <div class="log-list mt30"
        [class.show]="showTable">
        <n-data-table #dt
            [style.height]="showTable ? '400px' : '1px'"
            id="exportlogList"
            [loading]="tableLoading"
            [config]="tableConfig"
            [columnDefs]="tableColumnDefs">
            <ng-template nTemplate
                [meta]="{field: 'status'}"
                let-data="rowData">
                <svg class="icon">
                    <use [attr.xlink:href]="icon[data.status]"></use>
                </svg>
                <span [class.red]="data.status === downloadStatus.failed">
                    {{statusMap[data.status]}}
                </span>
            </ng-template>
        </n-data-table>
    </div>

    <n-footer>
        <button nButton
            type="button"
            (click)="onClose()"
            [label]="i18n.closeBtn">
        </button>
    </n-footer>
</n-slide-window>

<!-- 按节点导出-高危提示底部元素 -->
<ng-template #template>
    <div class="prompt-bottom-content">
        <n-radio-group [(ngModel)]="isExportAllInPrompt">{{i18n.includeManagementLogLab}}<n-help-icon
                class="title-tip mr20"
                [content]="i18n.includeManagementLogTip">
            </n-help-icon>
            <n-radio
                id="export-management-log"
                [value]="IncludeManageLog.IS">
                {{i18n.yes}}
            </n-radio>
            <n-radio
                id="not-export-management-log"
                [value]="IncludeManageLog.NOT">
                {{i18n.no}}
            </n-radio>
        </n-radio-group>
        <ng-container *ngIf="isExportAllInPrompt === IncludeManageLog.IS">
            {{i18n.includeManagementLogEnableInfo}}
            <br>
            <div [innerHTML]="includeManageLog"></div>
        </ng-container>
    </div>
</ng-template>
